import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IGetUserRefreshTokenCountParams {
  username: string;
  domainName: string;
}

export interface IGetUserRefreshTokenCountResult extends IResult {
  refreshTokenCount: number;
}

export class GetUserRefreshTokenCountRequest extends Request<IGetUserRefreshTokenCountParams, IGetUserRefreshTokenCountResult> {
  constructor(params: IGetUserRefreshTokenCountParams) {
    super('getUserRefreshTokenCount', params);
  }
}
